import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class SubscriptionCreditNote
 *
 */
export class SubscriptionCreditNote extends Model {

    static get validationModel() {

        return {
            date: {
                label: 'CREDIT_NOTE_DATE',
            },
            quantity: {
                label: 'QUANTITY',
                messages: {
                    greaterThan: 'QUANTITY_PLEASE_ENTER_A_VALUE_MORE_THAN_0'
                },
            },
            price: {
                label: 'PRICE',
                messages: {
                    greaterThan: 'PRICE_PLEASE_ENTER_A_VALUE_MORE_THAN_0'
                },
            },
        };
    }
}

AccessorsMutatorsDecorator('id', 'subscription_id', 'ident', 'date', 'payment_type', 'invoice_ident',
    'attachment', 'items', 'notes', 'total', 'created_at', 'updated_at')(SubscriptionCreditNote);


// WEBPACK FOOTER //
// ./src/pms-api/models/subscription-credit-note.model.js